// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2mLFH","footer":"ModalCreateQualiphyProcedure_footer__EuT5g","additionData":"ModalCreateQualiphyProcedure_additionData__1tof3"};